import useWindowResize from '@rio-cloud/rio-uikit/useWindowResize';
import { useState } from 'react';

export const MOBILE_BREAKPOINT = 500;

const getIsMobile = () => typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT;

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(getIsMobile);

    useWindowResize(() => {
        setIsMobile(getIsMobile());
    });

    return isMobile;
};
